<template>
  <v-container fluid class="px-0" style="background-color: transparent">
    <v-row>
      <v-col cols="12" md="3" v-for="(chartData, index) in charts" :key="index">
        <v-card class="card-shadow border-radius-xl">
          <v-card-title class="text-h6 pb-2" style="color: black">{{
            chartData.title
          }}</v-card-title>
          <v-divider
            style="
              height: 40px !important;
              width: 80% !important;
              background-color: grey;
            "
          ></v-divider>
          <v-card-text v-if="renderComponent && loading == false">
            <ChartW :chartId="index" :chartData="chartData"></ChartW>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { sync } from "vuex-pathify";
import ChartW from "./ChartW.vue";
export default {
  data() {
    return {
      selectedTab: 0,
      charts: [
        { title: "Ээлжит хичээлийн дүн", approved: 210, pending: 32 },
        { title: "Хичээлийн дүн шивэлт", approved: 512, pending: 160 },
        { title: "Судлагдаxууны дүн", approved: 0, pending: 256 },
        { title: "Шалгалт", approved: 0, pending: 64 },
        { title: "Төгсөлтийн бүртгэл", approved: 0, pending: 16 },
        { title: "Баримт бичиг олголт", approved: 0, pending: 0 },
        { title: "Элсэлтийн бүртгэл", approved: 0, pending: 0 },
      ],
      selectedProgram: null,
      lessons: null,
      yearUnelgeeScores: {
        approved: 0,
        pending: 0,
      },
      year2UnelgeeScores: {
        approved: 0,
        pending: 0,
      },
      renderComponent: true,
      loading: true,
      tests: null,
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    ...sync("*"),
  },
  components: {
    ChartW,
  },
  props: {
    selectedClassGroup: {
      type: Object,
      required: true,
    },
    classStudents: {
      type: Array,
      required: true,
    },
  },
  created() {
    this.selectedProgram = Object.assign({}, this.selectedClassGroup);
    this.readLessons();
    this.readGrades();
  },
  methods: {
    readLessons() {
      this.userData.school.ref
        .collection("lessons-" + this.userData.school.currentYear)
        .where("classGroupRefs", "array-contains", this.selectedProgram.ref)
        .orderBy("courseInfo.COURSE_NAME", "asc")
        .onSnapshot((docs) => {
          this.lessons = [];
          // var electiveLessonNumber = 0;
          // var mandatoryLessonNumber = 0;
          docs.forEach(async (doc) => {
            let lesson = doc.data();
            lesson.ref = doc.ref;
            lesson.id = doc.id;

            if (!lesson.deleted) {
              // if (lesson.courseInfo.ENROLLMENT_CATEGORY == "MANDATORY") {
              //   mandatoryLessonNumber++;
              // } else {
              //   electiveLessonNumber++;
              // }

              // lesson.students = this.selectedProgram.students;

              lesson.courseInfo.ENROLLMENT_CATEGORY_NAME =
                lesson.courseInfo.ENROLLMENT_CATEGORY_NAME.replace(
                  "судлах",
                  ""
                );

              // if (lesson.startEnd) {
              //   if (
              //     lesson.startEnd["semester-1"] &&
              //     lesson.startEnd["semester-1"].available
              //   ) {
              //     if (
              //       this.selectedProgram["year1UnelgeeScores"] &&
              //       this.selectedProgram["year1UnelgeeScores"][lesson.id]
              //     ) {
              //       var tmp =
              //         this.selectedProgram["year1UnelgeeScores"][lesson.id];

              //       if (tmp.approvedNumber > tmp.numberStudentsOfUnelgee) {
              //         tmp.approvedNumber = tmp.numberStudentsOfUnelgee;
              //       }
              //       console.log(
              //         tmp.approvedNumber,
              //         tmp.numberStudentsOfUnelgee,
              //         this.selectedProgram["year1UnelgeeScores"][lesson.id]
              //       );
              //       this.year1UnelgeeScores.approved =
              //         this.year1UnelgeeScores.approved + tmp.approvedNumber;
              //       this.year1UnelgeeScores.pending =
              //         this.year1UnelgeeScores.pending +
              //         (tmp.numberStudentsOfUnelgee - tmp.approvedNumber);
              //     }
              //   }
              //   if (
              //     (lesson.startEnd["semester-2"] &&
              //       lesson.startEnd["semester-2"].available) ||
              //     (lesson.startEnd["semester-3"] &&
              //       lesson.startEnd["semester-3"].available)
              //   ) {
              //     if (
              //       this.selectedProgram["year2UnelgeeScores"] &&
              //       this.selectedProgram["year2UnelgeeScores"][lesson.id]
              //     ) {
              //       tmp = this.selectedProgram["year2UnelgeeScores"][lesson.id];

              //       if (tmp.approvedNumber > tmp.numberStudentsOfUnelgee) {
              //         tmp.approvedNumber = tmp.numberStudentsOfUnelgee;
              //       }

              //       this.year2UnelgeeScores.approved =
              //         this.year2UnelgeeScores.approved + tmp.approvedNumber;
              //       this.year2UnelgeeScores.pending =
              //         this.year2UnelgeeScores.pending +
              //         (tmp.numberStudentsOfUnelgee - tmp.approvedNumber);
              //     }
              //   }
              // }

              if (
                this.selectedProgram["year1UnelgeeScores"] &&
                this.selectedProgram["year1UnelgeeScores"][lesson.id]
              ) {
                var tmp = this.selectedProgram["year1UnelgeeScores"][lesson.id];

                if (tmp.approvedNumber > tmp.numberStudentsOfUnelgee) {
                  tmp.approvedNumber = tmp.numberStudentsOfUnelgee;
                }
                console.log(
                  tmp.approvedNumber,
                  tmp.numberStudentsOfUnelgee,
                  this.selectedProgram["year1UnelgeeScores"][lesson.id]
                );
                this.yearUnelgeeScores.approved =
                  this.yearUnelgeeScores.approved + tmp.approvedNumber;
                this.yearUnelgeeScores.pending =
                  this.yearUnelgeeScores.pending +
                  (tmp.numberStudentsOfUnelgee - tmp.approvedNumber);
              }

              if (
                this.selectedProgram["year2UnelgeeScores"] &&
                this.selectedProgram["year2UnelgeeScores"][lesson.id]
              ) {
                tmp = this.selectedProgram["year2UnelgeeScores"][lesson.id];

                if (tmp.approvedNumber > tmp.numberStudentsOfUnelgee) {
                  tmp.approvedNumber = tmp.numberStudentsOfUnelgee;
                }

                this.yearUnelgeeScores.approved =
                  this.yearUnelgeeScores.approved + tmp.approvedNumber;
                this.yearUnelgeeScores.pending =
                  this.yearUnelgeeScores.pending +
                  (tmp.numberStudentsOfUnelgee - tmp.approvedNumber);
              } else {
                this.yearUnelgeeScores.pending =
                  this.yearUnelgeeScores.pending + this.classStudents.length;
              }
            }
          });

          // if (!this.lessonNumberSetupped) {
          //   var tmp = {};
          //   tmp["year" + this.selectedHalfYearId + "UnelgeeScores"] = this
          //     .selectedProgram[
          //     "year" + this.selectedHalfYearId + "UnelgeeScores"
          //   ]
          //     ? this.selectedProgram[
          //         "year" + this.selectedHalfYearId + "UnelgeeScores"
          //       ]
          //     : {};
          //   tmp[
          //     "year" + this.selectedHalfYearId + "UnelgeeScores"
          //   ].mandatoryLessonNumber = mandatoryLessonNumber;

          //   tmp[
          //     "year" + this.selectedHalfYearId + "UnelgeeScores"
          //   ].electiveLessonNumber = electiveLessonNumber;

          //   this.selectedProgram.ref.update(tmp);
          //   this.lessonNumberSetupped = true;
          // }

          this.charts[0].approved = this.yearUnelgeeScores.approved;
          this.charts[0].pending = this.yearUnelgeeScores.pending;
          this.charts[1].approved = this.year2UnelgeeScores.approved;
          this.charts[1].pending = this.year2UnelgeeScores.pending;
          console.log(this.charts);

          this.loading = false;
          this.$forceUpdate();
          this.forceRerender();
        });
    },
    async forceRerender() {
      this.renderComponent = false;
      await this.$nextTick();
      this.renderComponent = true;
    },
    readGrades() {
      this.userData.school.ref
        .collection("state-exam-students")
        .where(
          "STUDENT_GROUP_ID",
          "==",
          Number(this.selectedClassGroup.STUDENT_GROUP_ID)
        )
        .get()
        .then((docs) => {
          this.tests = [];
          this.charts[3].approved = 0;
          this.charts[3].pending = 0;
          docs.forEach((doc) => {
            let test = doc.data();
            test.ref = doc.ref;
            test.id = doc.id;

            for (var examId in test.exams) {
              if (test.exams[examId].APPROVAL_STATUS == "APPROVED") {
                this.charts[3].approved++;
              } else {
                this.charts[3].pending++;
              }
            }
            this.tests.push(test);
          });
          this.$forceUpdate();
          this.forceRerender();
        });
    },
  },
};
</script>

<style scoped></style>
